import React from 'react';
import { SEOTableColumn } from 'src/api/models/SEOTable';
import { ContentCell, ContentGrid, EmptyCell, HeadCell, TitleCell } from './Cell.styles';
import Typography from 'atoms/Typography/Typography';
import AnchorCellHandler from './AnchorCellHandler';
import { cssVar } from 'styles/helper';
import CellContent from './CellContent';

interface Cell extends SEOTableColumn {
  isEmpty?: boolean;
  isHead?: boolean;
  isTitle?: boolean;
  rowIndex?: number;
  className?: string;
  entries?: SEOTableColumn[];
}

const Cell = ({ isEmpty, isHead, text, isTitle, anchorTo, rowIndex, entries }: Cell): JSX.Element => {
  if (isEmpty) {
    return <EmptyCell />;
  }

  if (isHead) {
    return (
      <HeadCell>
        <Typography
          type='paragraph'
          size='xl'
          fontWeight='font-weight-semibold'
          color='text-primary'
          textAlign='center'
          className='head-cell-text'
        >
          {text}
        </Typography>
      </HeadCell>
    );
  }

  const backgroundColor = rowIndex % 2 === 0 ? 'bg-secondary' : 'bg-primary';

  if (isTitle) {
    return (
      <TitleCell
        backgroundColor={cssVar(backgroundColor)}
        className='title-cell'
      >
        <AnchorCellHandler href={anchorTo}>
          <Typography
            type='paragraph'
            size='sm'
            fontWeight='font-weight-semibold'
            textAlign='left'
            color='text-primary'
          >
            {text}
          </Typography>
        </AnchorCellHandler>
      </TitleCell>
    );
  }

  return (
    <ContentCell backgroundColor={cssVar(backgroundColor)}>
      <ContentGrid>
        {entries.map((entry, index) => (
          <CellContent
            key={index}
            text={entry.text}
            checked={entry.checked}
            href={entry.anchorTo}
          />
        ))}
      </ContentGrid>
    </ContentCell>
  );
};

export default Cell;
